import LessonsDao from '../dao/lessons.dao';
import type { Environment } from '../interfaces/environment';

export abstract class LessonsService {
  static async getStudentLessonsByUnit(
    env: Environment,
    contactId: string,
    unitId?: number
  ) {
    const lessons = await LessonsDao.getStudentLessonsByUnit(
      env,
      contactId,
      unitId
    );
    return lessons.filter((lesson) => lesson.type === 'Lesson');
  }
}
